import roles from '../../data/roles';
import { Role } from '../models/Role';

/**
 * Validates if a user has birdwatching access based on specific role IDs
 * @param userRoles Array of user roles from useProfile hook
 * @returns true if user has any of the birdwatching-related roles
 */
/* eslint-disable import/prefer-default-export */
export function validateBirdwatchingAccess(userRoles: Role[] = []): boolean {
  const BIRDWATCHING_ROLE_IDS = [
    roles.BIRDSEYE_REVIEW_QUEUE_ACCESS,
    roles.CLINICAL_DOCUMENT_INTEGRITY_REVIEW,
    roles.CHART_PREP_REVIEW,
  ];

  const userRoleIds = userRoles.map((role) => role.id);
  return BIRDWATCHING_ROLE_IDS.some((roleId) => userRoleIds.includes(roleId));
}
